import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect } from 'react-router-dom'

import { Helmet } from 'react-helmet'
import { Page, Section, P, Breadcrumb, Crumb, Flex } from '@framework'
import { RebateTransactionTable } from '@components/Tables'
import { viewSinglePlayerRebate } from '@store/actions/report.action'
import moment from 'moment';

class PlayerRebateDetailPage extends Component {

  componentDidMount () {
    const { viewSinglePlayerRebate, match } = this.props
    viewSinglePlayerRebate({ playerId: match.params.id })
  }


  render () {
    const { data, playerDetail, startDate, endDate } = this.props
    const { phoneNumber, totalRebate, txId } = playerDetail
    if (!data.length) {
      return <Redirect to='/manage/rebate-report' />
    }

    return (
      <Page fluid paperWhite className='scope-user-detail'>
        <Helmet title='OPS Admin: User Detail' />
        <Breadcrumb>
          <Crumb to='/manage/workspace'>Home</Crumb>
          <Crumb to='/manage/rebate-report'>Rebate Transaction Detail</Crumb>
          <Crumb>Detail</Crumb>
        </Breadcrumb>
        <Section>
          <Flex>
            <Flex column>
              <P>Phone: {phoneNumber}</P>
              <P>Rebate Bonus: {totalRebate}</P>
              <P>Start Date: {moment(startDate).format('DD/MM/YYYY h:mm:ss a')}</P>
              <P>End date: {moment(endDate).format('DD/MM/YYYY h:mm:ss a')}</P>

            </Flex>
   
          </Flex>
          {txId && <RebateTransactionTable txIds={txId} />}
      
        </Section>
    
      </Page>
    )
  }
}

export default connect(
  ({ report:
    { 
      rebateReport : {
        list: { data, startDate, endDate },
        view: { listDataIndex }
      }
    }
  }) => ({
    data,
    playerDetail: data[listDataIndex] ? data[listDataIndex] : {},
    startDate,
    endDate 
  }), 
  dispatch => bindActionCreators({
    viewSinglePlayerRebate,
  }, dispatch)
)(PlayerRebateDetailPage)
